import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeagoModule, TimeagoFormatter, TimeagoClock } from 'ngx-timeago';
import { CustomFormatter } from './services/custom-formatter.service';
import { CustomClock } from './services/custom-clock.service';

@NgModule({
  imports: [CommonModule, TimeagoModule.forRoot({ formatter: { provide: TimeagoFormatter, useClass: CustomFormatter }, clock: { provide: TimeagoClock, useClass: CustomClock } })],
})
export class SharedUtilsTimeagoModule {}
